import { render, staticRenderFns } from "./ChooseGender.vue?vue&type=template&id=3bde5764&scoped=true"
import script from "./ChooseGender.vue?vue&type=script&lang=js"
export * from "./ChooseGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde5764",
  null
  
)

export default component.exports